import { IconButton, Paper, Tooltip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { makeStyles } from '@material-ui/styles';
import React, { PropsWithChildren, ReactElement, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useParentPath } from '../../../hooks/router';
import { TestId } from '../../Testing/TestId';
import { Action } from '../../layout/actions';
import { Header } from '../../layout/main-layout';

export interface Props {
  title: string;
  tabs: ReactElement;
  backButtonTitle: string;
  backButtonLink: string;
  actions?: Action[];
}

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    padding: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    height: '100%',
    padding: 40,
  },
  requestLink: {
    minWidth: 187,
    whiteSpace: 'nowrap',
  },
});

export function WithTabs({
  title,
  backButtonTitle,
  backButtonLink,
  children,
  tabs,
  actions,
}: PropsWithChildren<Props>): ReactElement {
  const classes = useStyles();
  const parent = useParentPath();
  const parentPathRef = useRef(parent);

  return (
    <>
      <Header
        title={title}
        backLink={
          <TestId testId={'back-link'}>
            <Tooltip title={backButtonTitle}>
              <IconButton
                component={Link}
                to={parentPathRef.current ?? backButtonLink}>
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
          </TestId>
        }
        actions={actions}
      />
      <Paper className={classes.container} elevation={1}>
        {tabs}
        <div className={classes.content}>{children}</div>
      </Paper>
    </>
  );
}
